import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { LOGO_URL } from "@/lib/brand";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F8F9FA]">
      <div className="w-full max-w-md">
        <img src={LOGO_URL} alt="Sollute Ocupacional" className="h-12 w-auto mb-10" />
        {sent ? (
          <div className="card text-center" data-testid="forgot-sent-card">
            <div className="w-16 h-16 bg-emerald-900 mx-auto flex items-center justify-center mb-5 rounded-full">
              <i className="fa-solid fa-envelope-circle-check text-white text-2xl"></i>
            </div>
            <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 mb-3">Verifique seu e-mail</h1>
            <p className="text-sm text-slate-600 mb-6 text-justify">
              Se a conta existir, enviamos um link para redefinir sua senha. O link é válido por <strong>72 horas</strong>.
              Não esqueça de verificar a pasta de spam.
            </p>
            <Link to="/login" className="btn btn-secondary w-full justify-center" data-testid="forgot-back-link">
              <i className="fa-solid fa-arrow-left"></i> Voltar para o login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="card" data-testid="forgot-form">
            <div className="overline mb-2">Recuperação de senha</div>
            <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 mb-6">Esqueci minha senha</h1>
            <p className="text-sm text-slate-600 mb-6 text-justify">
              Informe o e-mail cadastrado e enviaremos um link para você criar uma nova senha.
            </p>
            <label className="label">E-mail</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="input mb-6" autoComplete="email" data-testid="forgot-email-input" />
            <button type="submit" disabled={busy} className="btn btn-primary w-full justify-center" data-testid="forgot-submit-button">
              {busy ? <i className="fa-solid fa-circle-notch fa-spin"></i> : <i className="fa-solid fa-paper-plane"></i>}
              Enviar link
            </button>
            <div className="mt-6 text-sm text-slate-600 text-center">
              <Link to="/login" data-testid="forgot-to-login-link" className="text-slate-500 hover:text-emerald-900">
                ← Voltar para o login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
